<template>
  <!-- 密码登录 -->
  <div class="box-input">
    <!-- 账号 -->
    <el-input
      v-model="myusername"
      placeholder="请输入手机号/邮箱"
      :prefix-icon="User"
      autocomplete="off"
      :class="{ 'focus-border': mydata.focusUsername }"
      @focus="mydata.focusUsername = true; mydata.readonlyInput = false"
      @blur="mydata.focusUsername = false"
      :readonly="mydata.readonlyInput"
    />

    <!-- 密码 -->
    <el-input
      v-model="mypassword"
      type="password"
      placeholder="请输入密码"
      show-password
      :prefix-icon="Lock"
      autocomplete="off"
      :class="{ 'focus-border': mydata.focusPassword }"
      @focus="mydata.focusPassword = true; mydata.readonlyInput = false"
      @blur="mydata.focusPassword = false"
      :readonly="mydata.readonlyInput"
    />
  </div>
</template>

<script setup>
import { User, Lock } from "@element-plus/icons-vue";
import { reactive } from "vue";
// 账号
const myusername = defineModel("myusername");
// 密码
const mypassword = defineModel("mypassword");

const mydata = reactive({
  focusUsername: false,
  focusPassword: false,
  readonlyInput:false
});
</script>

<style scoped lang="scss">
.box-input {
  ///////人物图标 与 锁图标
  :deep(.el-icon.el-input__icon) {
    // border:1px solid red;
    font-size: 20px;
  }

  //密码框后的小眼睛
  :deep(.el-icon.el-input__icon.el-input__password) {
    font-size: 20px;
    // color:blue;
  }

  //整个输入框
  :deep(.el-input) {
    width: 100% !important;
    height: 48px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
  //整个输入框
  :deep(.el-input > .el-input__wrapper) {
    box-shadow: none;
    border: 1px solid #dbdbdb;
    // border: 1px solid red;
    > .el-input__inner {
      font-size: 15px;
      // color:red;
    }
  }

  :deep(.el-input.el-input--suffix) {
    // border:1px solid blue;
    margin-bottom: 0px;
  }
  //输入框中提示文字
  :deep(.el-input__wrapper > .el-input__inner::placeholder) {
    color: #666666;
    font-size: 14px;
    font-weight: 300;
    // color:blue;
  }
}
//鼠标在输入框中时，边框变蓝色
.focus-border {
  :deep(.el-input__wrapper) {
    border: 1px solid #409eff !important;
    .el-icon {
      color: #409eff;
    }
  }
}
</style>